import { getCountryCode } from "src/utils/meristemContext";
import { registerHandler } from "../handler";

declare const window: Window & {
  nf0?: any;
};

let didInit = false;

function ensureInit() {
  if (didInit) {
    return;
  }
  if (window.nf0) {
    // For this pixel, tracking properties for a user is another event
    window.nf0("trackStructEvent", "country_code", getCountryCode());
    didInit = true;
  }
}

export default function registerHandlers() {
  registerHandler("init", () => {
    ensureInit();
    window.nf0?.("trackPageView", getCountryCode());
  });

  registerHandler("lead", () => {
    ensureInit();
    window.nf0?.(
      "trackStructEvent",
      "custom_conversion",
      "lead",
      getCountryCode()
    );
  });

  registerHandler("purchase", () => {
    ensureInit();
    window.nf0?.(
      "trackStructEvent",
      "custom_conversion",
      "signup",
      getCountryCode()
    );
  });

  registerHandler("answerWhereDidYouHear", (response) => {
    ensureInit();
    window.nf0?.(
      "trackStructEvent",
      "custom_conversion",
      "hear_about_us",
      ...response,
      getCountryCode()
    );
  });
}
